<div
  style="
    width: 380px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
  "
>

  <div
    style="
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    "
  >
    Upload Profile Image
  </div>

  <!-- BODY -->
  <div style="text-align:center; padding: 20px 0;">

    <!-- SHOW VIDEO BEFORE CAPTURE -->
    <video
      *ngIf="!preview"
      #video
      autoplay
      playsinline
      style="
        width: 100%;
        border-radius: 12px;
        background: #000;
      "
    ></video>

    <!-- SHOW PREVIEW AFTER CAPTURE -->
    <img
      *ngIf="preview"
      [src]="preview"
      style="
        width:140px;
        height:140px;
        margin-top: 15px;
        border-radius: 50%;
        object-fit: cover;
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      "
    />

    <canvas #canvas style="display:none;"></canvas>

    <!-- Hidden Input For Gallery -->
    <input
      type="file"
      accept="image/*"
      #galleryInput
      style="display:none"
      (change)="onGalleryPick($event)"
    />

  </div>

  <!-- BUTTONS -->
  <div style="text-align:center">

    <!-- Capture button only when video visible -->
    <button *ngIf="!preview" nbButton status="success" class="me-2" (click)="captureImage()">
      Capture
    </button>

    <!-- Recapture button only when preview visible -->
    <button *ngIf="preview" nbButton status="warning" class="me-2" (click)="recapture()">
      Recapture
    </button>

    <button nbButton status="info" (click)="galleryInput.click()">
      Pick From Gallery
    </button>

  </div>

  <!-- FOOTER / UPLOAD -->
  <div style="text-align: right; padding-top: 10px;">
    <button nbButton status="primary" [disabled]="!preview" (click)="upload()">
      Upload
    </button>
  </div>

</div>
